/*
 * @Description:
 * @Author: JDY
 * @Date: 2021-04-15 21:05:26
 * @LastEditTime: 2021-04-26 10:31:26
 * @LastEditors: JDY
 */
import { requestPost, requestPut } from '@/api/api'
import pick from 'lodash.pick'

const list = {
    data () {
        return {
            form: this.$form.createForm(this), // 添加数据
            editingKey: '' // 当前编辑行
        }
    },
    methods: {
        /**
         * 添加
         * {
         *  form
         * }
         * @params
         */
        handleSubmitForm () {
            const { form: { validateFields } } = this
            validateFields((errors, values) => {
                console.log('values')
                console.log(errors)
                  console.log(values)
                if (!errors) {
                    this.loading = true
                    const { apiList } = this

                    requestPost(apiList.create, values)
                        .then(res => {
                            this.$notification.success({
                                message: res.msg
                            })
                            this.getLists()
                            this.form.resetFields()
                        })
                        .finally(() => {
                            this.loading = false
                        })
                }
            })
        },
        // input框编辑内容
        handleChange (value, id, column) {
            const newData = [...this.list]
            const target = newData.filter(item => id === item.id)[0]
            if (target) {
                target[column.dataIndex] = value
                this.list = newData
            }
        },
        // 编辑按钮
        handleEdit (id) {
            const newData = [...this.list]
            const target = newData.filter(item => id === item.id)[0]
            this.editingKey = id
            console.log('newData')
            console.log(newData)
            if (target) {
                target.editable = true
                this.list = newData
            }
        },
        /**
         * 编辑保存按钮
         * id
         */
        handleSave (id) {
            const newData = [...this.list]
            const target = newData.filter(item => id === item.id)[0]
            if (target) {
                this.list = newData
                delete target.editable
                const values = pick(target, this.fields)
                const { apiList } = this
                requestPut(apiList.update + id, values)
                    .then(res => {
                        this.$notification.success({
                            message: res.msg
                        })
                        this.editingKey = ''
                    })
            }
        },
        /**
         * 取消编辑行
         * {
         *  id: id
         * }
         * @param
         */
        handleCancel (id) {
            const newData = [...this.list]
            const target = newData.filter(item => id === item.id)[0]
            this.editingKey = ''
            if (target) {
                delete target.editable
                this.getLists()
                this.list = newData
            }
        }
    }
}
export default list
